import axios from 'axios';
import moment from 'moment';
import '@/filters';
import users from '@/users';
import enquiriesTools from '@/employee/enquiries/enquiriesTools';

export default {
  name: 'customerDetails',
  components: {
    CustomerPropertiesComp: require('@/employee/enquiries/customerProperties.vue').default,
    inputWithCopy: require('@/common/inputWithCopy/inputWithCopy.vue').default,
    inputWithViewDetails: require('@/common/inputWithViewDetails/inputWithViewDetails.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
    LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
    MenuListItem: require('@/employee/enquiries/menuListItem.vue').default,
  },
  mixins: [users, enquiriesTools],
  data: function () {
    return {
      settingFor: 'customer',
      isLoading: true,

      menuVisible: true,
      customerName: '',
      lang: '',
      generalReports: [],
      customerReports: [],
      properties: [],
      property: null,
      propertyId: null,

      customerAllData: null,
      accountDetails: null,
      customerDetails: null,
      connections: null,

      lastInvoiveIssueAmount: '',
      lastInvoiveIssueDate: '',
      lastReadingDate: '',
      lastReading: '', 

      subCons: {},

      propId: null,
      custkey: null,

      pagesLoaded: ['CustomerAllDetails','CustomerDetails', 'AccountDetails', 'Connections', 'Properties']
    }
  },
  mounted() {
    this.goToDefaultTab(this.selectedTab);
  },
  computed: {
    connTableData: function () {
      //console.log("cons", this.connections)
      if (!this.connections)
        return;

      let data = this.connections.filter(a => a.title != 'connId' && a.title != 'mainConnId' && a.title != 'meterId');

      let arr = [], indx = 1, i = 1;

      for (i; i < data.length; i++) {
        if (data[i].title == 'connNo') {
          arr.push({ data: data.slice(i - indx, i), id: arr.length });
          indx = 1;
        }
        else
          indx++;
      }

      arr.push({ data: data.slice(i - indx, i), id: arr.length });

      //console.log("connTableData", arr);
      return arr;
    },
  },
  watch: {
    selectedTab: function (val) {
      //console.log("selectedTab", val);
      this.changeUrlLink(val);
    }
  },
  methods: {
    init() {
      this.propId = this.$route.params.propertyId;
      this.custkey = this.$route.params.custkey;

      this.selectedTab = 'CustomerAllDetails';
      this.getCustomerAllDetails();
    },
    getCustomerAllDetails() {
      this.customerAllData = null;

      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/getCustomerAllDetails', parameters)
        .then(response => {
          //console.log('response', response);
          if (response.data.data.status == 0) {
            //console.log('getCustomerAllDetails', response.data);

            //this.getProperties(response.data.custData.custkey);

            if (response.data.custData.hasConnection) {
              response.data.custData.connection.connDate = moment(response.data.custData.connection.connDate).format('DD/MM/YYYY');
            }

            this.customerAllData = response.data.custData;
            this.getAdditionalData();
          }
          else {
            this.customerAllData = null;
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.customerAllData = null;
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getAdditionalData() {
      this.getSubConnections();
      this.getCustomerDetails();
      this.getAccountDetails();
      this.getProperties();
    },
    getSubConnections() {
      if (this.customerAllData.connection == null)
        return;

      axios.get('/Enquiries/getSubConnections?connId=' + this.customerAllData.connection.connectionId)
        .then(response => {
          if (response.data.data.status == 0) {
            this.subCons = response.data.items;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed(e);
          this.$oldAlertMsg(e, 4);
          return false;
        })
    },
    getCustomerDetails() {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/getCustomerDetails', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            //console.log('getCustomerDetails', response.data);
            if (response.data.items && response.data.items.length > 0)
              response.data.items.forEach(d => {
                if (d && d.description)
                  d.description = d.description.trim();

                if (d.description && d.description.toLowerCase() == 'null')
                  d.description = null;
              });

            this.customerDetails = response.data.items.filter(a => a.title != 'customerId');
            this.customerName = response.data.items.filter(a => a.title == 'Name').length == 0 ? '' : response.data.items.filter(a => a.title == 'Name')[0].description;
          }
          else {
            this.customerDetails = null;
            this.customerName = '';
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.customerDetails = null;
          this.customerName = '';
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
        });
    },
    getAccountDetails() {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/getAccountDetails', parameters)
        .then(response => {
          //console.log('getAccountDetails', response.data);
          if (response.data.data.status == 0) {
            this.accountDetails = response.data.items.filter(a => a.title != 'Balance' && a.title != 'CurrencySymbol');
          }
          else {
            this.accountDetails = null;
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.accountDetails = null;
          this.$oldAlertMsg(e, 4);
        });
    },
    getProperties() {
      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/getProperties', parameters)
        .then(response => {
          if (response.status == 200) {
            this.properties = response.data.items;
            if (response.data.items.length > 0) {
              this.property = response.data.items[0];
              this.propertyId = this.propId == -1 ? response.data.items[0].propertyId : this.propId;
              this.getConnection();
            }
          }
          else
            this.getDataFailed();
        })
        .catch(e => { this.getDataFailed(e) })
    },
    getConnection() {
      var parameters = {
        prop: this.property,
        loginEmail: this.getLoginName(),
        Options: { pageSize: 10, total: 0, page: 1 }
      }

      axios.post('/Enquiries/getPropertyConnection', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.connections = response.data.items;
            this.connections.totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
        });
    },
    tableDoubleClick(selectedTab) {
      if (selectedTab == 'CustomerDetails' || selectedTab == 'AccountDetails')
        this.openCustomerDetails();
      else if (selectedTab == 'Connections')
        this.openConnectionDetails();
    },
    openConnectionDetails() {
      var ConnId = this.connections.filter(a => a.title == 'connId')[0].description;

      let routeData = this.$router.resolve({ name: 'connectionDetails', params: { ConnectionId: ConnId } });
      window.open(routeData.href, '_blank');
    },
    openCustomerDetails() {
      //let routeData = this.$router.resolve({ name: 'customerDetails', params: { CUSTKEY: this.custkey } });
      //window.open(routeData.href, '_blank');
    },

    selectProperty(propId, prop) {
      if (propId == this.propertyId)
        return;

      this.property = prop;
      this.propertyId = propId;
    },
    openMainConnectionDetails() {
      let routeData = this.$router.resolve({ name: 'connectionDetails', params: { ConnectionId: this.customerAllData.connection.mainConnId } });
      window.open(routeData.href, '_blank');
    },
  },
}
